"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_REQUEST = 'me/UPDATE/REQUEST';
exports.UPDATE_SUCCESS = 'me/UPDATE/SUCCESS';
exports.UPDATE_FAILURE = 'me/UPDATE/FAILURE';
//# sourceMappingURL=types.js.map